import { IImage, ImageId, IMAGES_SCHEMA } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import {
  IDeleteGateway,
  IGetGateway,
  ISaveGateway,
  IUploadGateway,
} from '../gateways';

export class ImageGateway
  implements
    IGetGateway<null, IApiResponse<IImage[]>>,
    ISaveGateway<IImage[], IApiResponse<IImage[]>>,
    IUploadGateway<FormData, IApiResponse<IImage[]>>,
    IDeleteGateway<ImageId, IApiResponse<IImage[]>>
{
  private readonly restCallBuilder: RestCallBuilder<IImage[]> =
    new RestCallBuilder<IImage[]>([]);

  get(): Observable<IApiResponse<IImage[]>> {
    return this.restCallBuilder
      .get('/images/')
      .validate(API_RESPONSE_SCHEMA(IMAGES_SCHEMA), 'Image.get')
      .handleMessages()
      .build();
  }

  getFile(imageId: ImageId): Observable<Blob> {
    return this.restCallBuilder.getBlob('/images/' + imageId);
  }

  save(query: IImage[]): Observable<IApiResponse<IImage[]>> {
    return this.restCallBuilder
      .post('/images/', query)
      .validate(API_RESPONSE_SCHEMA(IMAGES_SCHEMA), 'Image.save')
      .handleMessages()
      .build();
  }

  upload(query: FormData): Observable<IApiResponse<IImage[]>> {
    return this.restCallBuilder
      .upload('/images/upload/', query)
      .handleMessages()
      .build();
  }

  delete(query: ImageId): Observable<IApiResponse<IImage[]>> {
    return this.restCallBuilder
      .delete('/images/' + query)
      .handleMessages()
      .build();
  }
}
